import { z } from 'zod';
import { ObjectIdSchema } from '../../shared/object-id.schema';
import { StepTemplateDescriptionSchema, StepTemplateNameSchema, StepTemplateSchema } from '../../entities/step-template/step-template.schema';
/**
 * POST /api/v2/process/:processId/draft/step-templates — request
 *
 * `nodeIds` are `stableStepId`s of step or event nodes of THIS draft; the
 * server snapshots them, the client never sends content. The cap mirrors the
 * layout contracts' 500-node ceiling (`DeleteDraftStepsRequestSchema`).
 */ export const CreateStepTemplateRequestSchema = z.object({
    name: StepTemplateNameSchema,
    description: StepTemplateDescriptionSchema.default(''),
    nodeIds: z.array(ObjectIdSchema).min(1).max(500)
});
export const CreateStepTemplateResponseSchema = z.object({
    data: StepTemplateSchema
});

//# sourceMappingURL=create-step-template.schema.js.map